module.exports = __webpack_public_path__ + "img/vi_vn.e1f64139.png";